import { Component, OnDestroy } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { AcaoComercial } from "app/acao-comercial/model/acao-comercial.model";
import { AcaoComercialService } from "app/acao-comercial/services/acao-comercial.service";
import { StatusMovimentacao } from "app/auxiliares/models/status-movimentacao.model";
import { StatusMovimentacaoService } from "app/auxiliares/services/status-movimentacao.service";
import { BaseActionDialogComponent, BaseActionDialogData } from "app/base-module/base-action-dialog";
import { BaseV2Component } from "app/base-module/base-component-v2/base-component-v2.component";
import { BaseV2Params } from "app/base-module/base-component-v2/base-component-v2.types";
import { AuthService } from "app/base-module/base-service/auth.service";
import { ClienteModel } from "app/clientes/models/cliente.model";
import { ClienteService } from "app/clientes/services/cliente.service";
import { ParametroService } from "app/parametros/services/parametro.service";
import { Estrategia } from "app/renda-variavel/models/estrategia.model";
import { EstrategiaService } from "app/renda-variavel/services/estrategia.service";
import { DIALOG_CANCEL_ACTION, DialogCancelAction } from "app/shared/dialog-constants";
import { ApiResponseDataNonNullable } from "app/shared/models/api-response.model";
import { NullablePartial } from "app/shared/models/utility-types.model";
import { UserRoleEnum } from "app/usuarios/models/user-role.enum";
import { Usuario } from "app/usuarios/models/user.model";
import { debounceTime, distinctUntilChanged, finalize, map, Observable, Subject, takeUntil, tap } from "rxjs";
import { DateUtils } from "src/utils/date-utils";
import { AlteraValorBoletaComponent } from "../altera-valor-boleta/altera-valor-boleta.component";
import { ConfirmaBoletaComponent } from "../confirma-boleta/confirma-boleta.component";
import { BoletaModel, BoletaValorModel } from "../models/movimentacao-boleta/boleta.model";
import { BoletaValoresService } from "../services/boleta-valores.service";
import { BoletaService } from "../services/boleta.service";

@Component({
    selector: "app-cadastro-boleta",
    templateUrl: "./cadastro-boleta.component.html",
    styleUrls: ["./cadastro-boleta.component.scss"],
    providers: [EstrategiaService, BoletaValoresService],
})
export class CadastroBoletaComponent
    extends BaseV2Component<BoletaValorModel, BaseV2Params>
    implements OnDestroy {
    private readonly destroy$ = new Subject<void>();

    filteredClients!: Observable<ClienteModel[]>;

    existingBoletaID: string | null;
    existingAcaoComercial: string | null;
    existingType: string | null;

    existingClientID: string | null;
    listStatus: StatusMovimentacao[] = [];
    listAcaoComercial: AcaoComercial[] = [];
    listEstrategia: Estrategia[] = [];
    valorBoletado: number = 0;
    titulo!: string;
    retornoLista: string;
    valor_custodia: number = 0;

    cliente = new FormControl<string | ClienteModel>("");
    cliente_id = new FormControl<number | null>(null, [Validators.required]);
    valor = new FormControl<number>(0, [Validators.required]);
    assessor_name = new FormControl("", []);
    data_operacao = new FormControl<Date | null>(new Date(), [Validators.required]);
    statusBoleta = new FormControl("Informe o cliente...", []);
    status_id = new FormControl<number | null>(null, [Validators.required]);
    numero_xp = new FormControl("", []);
    telefone = new FormControl("", []);
    email = new FormControl("", []);
    escritorio_id = new FormControl("", []);
    escritorio = new FormControl("", []);
    observacao = new FormControl("", []);
    tipo_boleta = new FormControl("", []);
    acao_comercial_id = new FormControl<number | null>(null, []);
    estrategia_id = new FormControl<number | null>(null, [Validators.required]);
    vlr_executado = new FormControl<number>(0, []);
    valor_trades = new FormControl(0, []);
    valor_total_boleta = new FormControl<number>(0, []);

    initialValuesCadastroBoleta: NullablePartial<BoletaModel> = {
        cliente_id: null,
        valor: null,
        observacao: "",
        data_operacao: "",
        status_id: null,
        tipo_boleta: null,
        estrategia_id: null,
        acao_comercial_id: null,
        valor_total: 0,
    };

    user: Usuario;
    valorDetalhadoBoleta: boolean = false;
    loadingSpinner: boolean = false;
    loadingSpinnerStatus: boolean = false;
    loadingSpinnerEstrategia: boolean = false;

    vlr_min_boleta: number = 0;
    vlr_min_boleta_sw: number | null = null;
    vlr_min_primeira_boleta_sw: number | null = null;
    vlr_min_boleta_fop: number | null = null;
    vlr_min_primeira_boleta_fop: number | null = null;

    constructor(
        private _service: BoletaService,
        private _clienteService: ClienteService,
        private _statusService: StatusMovimentacaoService,
        private _Activatedroute: ActivatedRoute,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private route: Router,
        private _authService: AuthService,
        private _serviceParametro: ParametroService,
        private _serviceAcaoComercial: AcaoComercialService,
        private _serviceEstrategia: EstrategiaService,
        private _serviceBoletaValores: BoletaValoresService
    ) {
        super(dialog, snackBar);

        this.getAllParametros();
        this.getAllAcaoComercial();
        this.getAllEstrategias();

        this.existingBoletaID = this._Activatedroute.snapshot.params["id"];
        this.existingClientID = this._Activatedroute.snapshot.params["cliente_id"];
        this.existingType = this._Activatedroute.snapshot.params["tipo"];
        this.existingAcaoComercial = this._Activatedroute.snapshot.params["acao_comercial"];

        this.titulo = "Cadastro de Boleta de Renda Variável";
        this.retornoLista = "Lista de Boletas de Renda Variável";

        if (this.existingClientID) {
            this.getDadosCliente(this.existingClientID);
        }

        this.tipo_boleta.setValue(this.existingType);

        this.listStatus = [];

        if (this.existingBoletaID) {
            this.getAllStatus();
            this.getBoleta();
        }

        this.cliente.valueChanges
            .pipe(
                tap(() => (this.loadingSpinner = true)),
                debounceTime(300),
                distinctUntilChanged(),
                takeUntil(this.destroy$)
            )
            .subscribe({
                next: (query) => {
                    if (typeof query === "string" || typeof query === "number") {
                        this.loadingSpinner = true;
                        this.params.search = query;
                        this.filteredClients = this._clienteService
                            .search(this.params)
                            .pipe(map(response => response.data), finalize(() => (this.loadingSpinner = false)));
                    }
                },
            });

        const strUser = this._authService.getUser();
        try {
            this.user = JSON.parse(strUser || "{}") as Usuario;
        } catch (e: unknown) {
            this.user = {} as Usuario;
            this.showSnackMessage("Erro ao carregar usuário: " + e, "error");
        }
    }

    /**
     * Emite sinal de destruição e completa o subject para limpar todas as subscriptions
     */
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    /**
     * Verifica se o formulário possui campos inválidos
     * @returns true se inválido
     */
    isInvalidForm(): boolean {
        if (!this.cliente_id.valid) {
            return true;
        }

        if (!this.valor.valid) {
            return true;
        }

        if (!this.data_operacao.valid) {
            return true;
        }

        if (!this.estrategia_id.valid) {
            return true;
        }

        return false;
    }

    /**
     * Retorna mensagem de erro para o campo valor
     * @returns Mensagem de validação
     */
    getErrorVolumeGlobalMessage(): string {
        return this.valor.hasError("required") ? "Valor Movimentado é um campo obrigatório" : "";
    }

    /**
     * Retorna mensagem de erro para o campo estratégia
     * @returns Mensagem de validação
     */
    getErrorEstrategiaMessage(): string {
        return this.estrategia_id.hasError("required") ? "Estratégia é um campo obrigatório" : "";
    }

    /**
     * Navega de volta à lista de boletas
     */
    retornarLista(): void {
        this.route.navigate(["/movimentacao/boleta/" + this.existingType]);
    }

    /**
     * Popula o formulário com os dados do cliente selecionado
     * @param cliente - Objeto do cliente
     */
    getCliente(cliente: ClienteModel): void {
        this.loadingSpinner = false;
        this.cliente_id.setValue(cliente.id);

        if (this.estrategia_id.value !== null) {
            this.getBoletaAberta();
        }

        this.preencheDadosCliente(cliente);
    }

    /**
     * Preenche os campos do formulário com os dados do cliente
     * @param cliente - Objeto do cliente
     */
    preencheDadosCliente(cliente: ClienteModel): void {
        this.numero_xp.setValue(cliente.numero_xp);
        this.telefone.setValue(String(cliente.telefone));
        this.email.setValue(cliente.email);
        this.assessor_name.setValue(cliente.assessor?.name ?? null);
        this.escritorio.setValue(cliente.escritorio?.nome_fantasia ?? null);
        if (cliente.carteira && cliente.carteira?.length > 0) {
            const carteiraItem = cliente.carteira[0];
            this.valor_custodia = parseFloat(carteiraItem.valor_total);
        }

        this.getByClienteBoleta();
    }

    /**
     * Exibe o nome do cliente no autocomplete
     * @param cliente - Objeto do cliente
     * @returns Nome do cliente
     */
    displayFn(cliente: ClienteModel): string {
        if (cliente) {
            return cliente.nome;
        }
        return "";
    }

    /**
     * Busca a contagem de boletas do cliente para definir o status inicial
     */
    getByClienteBoleta(): void {
        const clientId = Number(this.cliente_id.value);
        if (!clientId) return;

        this._service
            .getByClienteCount(clientId, this.estrategia_id.value ?? 0)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (result) => {
                    if (result.data?.qtd === 0) {
                        this.statusBoleta.setValue("Primeira Operação");
                        this.status_id.setValue(2);
                    } else {
                        this.statusBoleta.setValue("Boleta MRV");
                        this.status_id.setValue(1);
                    }
                },
                error: () => { },
                complete: () => { },
            });
    }

    /**
     * Carrega a lista de estratégias disponíveis
     */
    getAllEstrategias(): void {
        this.loadingSpinnerEstrategia = true;
        this._serviceEstrategia
            .getLista()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (list) => {
                    this.listEstrategia = list.data;
                },
                error: () => { },
                complete: () => {
                    this.loadingSpinnerEstrategia = false;
                },
            });
    }

    /**
     * Verifica se existe boleta aberta para o cliente na estratégia selecionada
     */
    getBoletaAberta(): void {
        if (!this.cliente_id.value || !this.estrategia_id.value) {
            this.showSnackMessage("Erro ao resgastar os dados do cliente", "error");
            return;
        }

        this._service
            .getBoletaAberta(this.cliente_id.value, this.estrategia_id.value)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (
                    result: ApiResponseDataNonNullable<BoletaModel> | ApiResponseDataNonNullable<{ qtd: number }>
                ) => {
                    if ("id" in result.data) {
                        if ("status_id" in result.data && result.data.status_id === 3) {
                            this.alertaBoletaFechada();
                        } else {
                            this.alertaBoletaAberta(result.data.id);
                        }
                    }
                },
                error: () => { },
                complete: () => { },
            });
    }

    /**
     * Exibe alerta informando que existe boleta aberta para o cliente
     * @param boleta_id - ID da boleta em aberto
     */
    alertaBoletaAberta(boleta_id: number): void {
        const dialogData: BaseActionDialogData = {
            title: "Boleta Aberta",
            message: "Já existe uma boleta aberta para esse cliente. Você deseja alterar o valor da boleta em aberto ?",
            type: "warning",
            confirmText: "Sim",
            cancelText: "Não",
            showCancel: true,
            callback: () => {
                this.route.navigate(["/movimentacao/boleta/cadastro/" + this.existingType + "/" + boleta_id]);
            },
        };

        const dialogRef = this.dialog.open(BaseActionDialogComponent, {
            width: "450px",
            data: dialogData,
        });

        dialogRef
            .afterClosed()
            .pipe(takeUntil(this.destroy$))
            .subscribe((result: boolean | undefined) => {
                if (result !== true) {
                    this.limpaFormulario();
                }
            });
    }

    /**
     * Limpa os campos do formulário relacionados ao cliente
     */
    limpaFormulario(): void {
        this.cliente.setValue("");
        this.numero_xp.setValue("");
        this.email.setValue("");
        this.telefone.setValue("");
        this.assessor_name.setValue("");
        this.escritorio.setValue("");
    }

    /**
     * Exibe alerta informando que a boleta está em negociação
     */
    alertaBoletaFechada(): void {
        const dialogData: BaseActionDialogData = {
            title: "Boleta Em Negociação",
            message:
                "Já existe uma boleta em negociação. Se você deseja alterar o valor da boleta, entre em contato com a Mesa de Operações!",
            type: "info",
            confirmText: "Fechar",
            showCancel: false,
            callback: () => {
                this.cliente.setValue("");
            },
        };

        this.dialog.open(BaseActionDialogComponent, {
            width: "400px",
            data: dialogData,
        });
    }

    /**
     * Valida regras de negócio antes de salvar a boleta
     * @returns true se válido
     */
    validaCadastro(): boolean {
        const valor_total_boleta: number = this.valor_total_boleta.value ? this.valor_total_boleta.value : 0;
        
        if (valor_total_boleta === 0) {
            this.showSnackMessage("O valor da Boleta não pode ser zerado!", "error");
            return false;
        }

        if (valor_total_boleta < this.vlr_min_boleta && this.vlr_min_boleta > 0) {
            this.showSnackMessage(
                "O valor da Boleta não pode ser menor do que R$ " +
                this.vlr_min_boleta.toLocaleString("pt-BR") +
                ",00" +
                " !",
                "error"
            );
            return false;
        }

        return true;
    }

    /**
     * Carrega a lista de status de movimentação
     */
    getAllStatus(): void {
        this.loadingSpinnerStatus = true;

        this._statusService
            .getLista({ tipo_produto: "RV" })
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (list) => {
                    this.listStatus = list.data ?? [];
                },
                error: () => { },
                complete: () => {
                    this.loadingSpinnerStatus = false;
                },
            });
    }

    /**
     * Carrega a lista de ações comerciais disponíveis
     */
    getAllAcaoComercial(): void {
        this._serviceAcaoComercial
            .getAll({ no_paginate: true })
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (list) => {
                    this.listAcaoComercial = list.data ?? [];
                },
                error: () => { },
                complete: () => {
                    if (this.existingAcaoComercial) {
                        this.acao_comercial_id.setValue(Number(this.existingAcaoComercial));
                        this.initialValuesCadastroBoleta.acao_comercial_id = Number(this.existingAcaoComercial);
                    }
                },
            });
    }

    /**
     * Busca os dados da boleta pelo ID para edição
     */
    getBoleta(): void {
        if (!this.existingBoletaID) {
            this.showSnackMessage("Boleta não existente", "error");
            return;
        }

        this.openLoading();
        this._service
            .getById(this.existingBoletaID)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (boleta) => {
                    this.initialValuesCadastroBoleta = boleta.data;

                    if (
                        boleta.data.bloqueio &&
                        this.user.role_id !== UserRoleEnum.ADMINISTRADOR_SISTEMAS &&
                        this.user.role_id !== UserRoleEnum.SOCIO_DIRETOR_ESPECIALISTA_RENDA_VARIAVEL &&
                        this.user.role_id !== UserRoleEnum.SOCIO_OPERADOR_RENDA_VARIAVEL
                    ) {
                        this.showSnackMessage("Boleta está bloqueada", "error");
                        this.retornarLista();
                    }

                    if (!boleta.data.cliente) {
                        this.showSnackMessage("Falha nos dados do cliente", "error");
                        return;
                    }

                    this.cliente_id.setValue(boleta.data.cliente?.id);
                    this.numero_xp.setValue(boleta.data.cliente.numero_xp);
                    this.telefone.setValue(String(boleta.data.cliente?.telefone));
                    this.email.setValue(boleta.data.cliente.email);
                    this.assessor_name.setValue(boleta.data.cliente.assessor?.name ?? null);
                    this.escritorio.setValue(boleta.data.escritorio?.cidade?.nome ?? null);
                    this.data_operacao.setValue(DateUtils.parseDateTimeToLocalDate(boleta.data.data_operacao));
                    this.observacao.setValue(boleta.data.observacao);
                    this.status_id.setValue(boleta.data.status_id !== null ? Number(boleta.data.status_id) : null);
                    this.cliente.setValue(boleta.data.cliente);
                    this.tipo_boleta.setValue(String(boleta.data.tipo_boleta));
                    this.acao_comercial_id.setValue(
                        boleta.data.acao_comercial_id !== null ? Number(boleta.data.acao_comercial_id) : null
                    );
                    this.estrategia_id.setValue(
                        boleta.data.estrategia_id !== null ? Number(boleta.data.estrategia_id) : null
                    );
                    this.vlr_executado.setValue(parseFloat(boleta.data.vlr_executado));

                    if (
                        boleta.data.cliente.carteira !== undefined &&
                        boleta.data.cliente.carteira !== null &&
                        boleta.data.cliente.carteira.length > 0
                    ) {
                        const carteiraItem = boleta.data.cliente.carteira[0];
                        this.valor_custodia = parseFloat(carteiraItem.valor_total);                        
                    } 

                    this.valorBoletado = parseFloat(boleta.data.valor);

                    this.valor.setValue(parseFloat(boleta.data.valor));
                    this.valor_trades.setValue(boleta.data.valor_total);

                    if (boleta.data.valor_total > 0) {
                        this.valorDetalhadoBoleta = true;
                        this.getValores();
                        this.valor_total_boleta.setValue(
                            parseFloat(boleta.data.valor) +
                            boleta.data.valor_total -
                            parseFloat(boleta.data.vlr_executado)
                        );
                    } else {
                        this.valor_total_boleta.setValue(
                            parseFloat(boleta.data.valor) - parseFloat(boleta.data.vlr_executado)
                        );
                    }
                },
                error: () => {
                    this.closeLoading();
                },
                complete: () => {
                    this.closeLoading();
                },
            });
    }

    /**
     * Busca os dados do cliente pelo ID e popula o formulário
     * @param cliente_id - ID do cliente
     */
    getDadosCliente(cliente_id: string): void {
        this.openLoading();
        this._clienteService
            .getById(cliente_id)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (cliente) => {
                    this.cliente.setValue(cliente.data);
                    this.getCliente(cliente.data);
                },
                error: () => {
                    this.closeLoading();
                },
                complete: () => {
                    this.closeLoading();
                },
            });
    }

    /**
     * Modal de edição
     */
    openConfirmaBoleta(): void {
        if (this.validaCadastro()) {
            const estrategia = this.listEstrategia.find((s) => s.id === (this.estrategia_id.value ?? 0));

            const dialogRef = this.dialog.open(ConfirmaBoletaComponent, {
                width: "800px",
                data: {
                    id: this.existingBoletaID,
                    cliente: this.cliente.value,
                    valor: this.valor.value,
                    data_operacao: this.data_operacao.value,
                    status_id: this.status_id.value,
                    observacao: this.observacao.value,
                    tipo_boleta: this.tipo_boleta.value,
                    acao_comercial_id: this.acao_comercial_id.value,
                    vlr_executado: this.vlr_executado.value,
                    estrategia_id: this.estrategia_id.value,
                    estrategia: estrategia?.nome ?? "N/A",
                    valor_total: this.valor_total_boleta.value,
                },
            });

            dialogRef
                .afterClosed()
                .pipe(takeUntil(this.destroy$))
                .subscribe((result: DialogCancelAction | null | undefined) => {
                    if (result && result !== DIALOG_CANCEL_ACTION) {
                        this.showSnackMessage("Boleta salva com sucesso!");
                        this.retornarLista();
                    }
                });
        }
    }

    /**
     * Carrega e processa os parâmetros de negócio do sistema
     */
    getAllParametros(): void {
        this._serviceParametro
            .getAll({})
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    for (const dados of data.data) {
                        if (dados.codigo === "VALOR_MIN_BOLETA_SWING") {
                            this.vlr_min_boleta_sw = parseFloat(dados.valor);
                        }

                        if (dados.codigo === "VALOR_MIN_PRIMEIRA_BOLETA_SWING") {
                            this.vlr_min_primeira_boleta_sw = parseFloat(dados.valor);
                        }

                        if (dados.codigo === "VALOR_MIN_BOLETA_FOP") {
                            this.vlr_min_boleta_fop = parseFloat(dados.valor);
                        }

                        if (dados.codigo === "VALOR_MIN_PRIMEIRA_BOLETA_FOP") {
                            this.vlr_min_primeira_boleta_fop = parseFloat(dados.valor);
                        }
                    }
                },
                error: () => {
                    this.loadingIndicator = false;
                },
                complete: () => {
                    this.loadingIndicator = false;
                },
            });
    }

    /**
     * Reage à mudança de estratégia selecionada, atualizando validações e status
     */
    onChangeSelectEstrategia(): void {
        this.getBoletaAberta();
        this.getByClienteBoleta();

        const estrategia = this.listEstrategia.find((s) => s.id === (this.estrategia_id.value ?? 0));
        this.vlr_min_boleta = parseFloat(estrategia?.valor_minimo_boleta?.toString() ?? "0");
    }

    /**
     * Busca os valores detalhados da boleta (lista de trades)
     */
    getValores(): void {
        this.loadingIndicator = true;
        this._serviceBoletaValores
            .getValoresById({ boleta_id: this.existingBoletaID })
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    this.length = data.meta.total;
                    this.rows = data.data;
                },
                error: () => {
                    this.loadingIndicator = false;
                },
                complete: () => {
                    this.loadingIndicator = false;
                },
            });
    }

    /**
     * Evento da paginação
     * @param {PageEvent} event
     */
    pageEvent(event: PageEvent): void {
        this.params.page = event.pageIndex + 1;
        this.params.per_page = event.pageSize;

        this.getValores();
    }

    /**
     * Abre o diálogo de edição de valor de trade
     * @param id - ID do valor a ser editado
     */
    openAlterar(id: number): void {
        const dialogRef = this.dialog.open(AlteraValorBoletaComponent, {
            width: "400px",
            data: {
                id,
            },
        });

        dialogRef
            .afterClosed()
            .pipe(takeUntil(this.destroy$))
            .subscribe((result: DialogCancelAction | null | undefined) => {
                if (result && result !== DIALOG_CANCEL_ACTION) {
                    this.getValores();
                    this.getBoleta();
                }
            });
    }

    /**
     * Exibe confirmação e remove o valor de trade pelo ID
     * @param id - ID do valor a ser removido
     */
    delete(id: number): void {
        const dialogData: BaseActionDialogData = {
            title: "Excluir Valor",
            message: "Deseja realmente excluir este item?",
            type: "error",
            confirmText: "Sim, excluir",
            cancelText: "Cancelar",
            showCancel: true,
            callback: () => {
                this.dialog.closeAll();

                this.loadingIndicator = true;
                this._serviceBoletaValores
                    .delete(id)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe({
                        next: (data) => {
                            this.loadingIndicator = false;
                            this.showSnackMessage(data.message);
                            this.getValores();
                        },
                        error: (error) => {
                            this.loadingIndicator = false;
                            this.showSnackMessage(error.error.message, "error");
                        },
                        complete: () => {
                            this.loadingIndicator = false;
                        },
                    });
            },
        };

        this.dialog.open(BaseActionDialogComponent, {
            width: "250px",
            disableClose: true,
            panelClass: "modal-delete",
            data: dialogData,
        });
    }

    /**
     * Atualiza o valor total da boleta com base no novo valor informado
     * @param event - Evento de mudança de valor
     */
    atualizaValor(): void {
        const total = (this.valor.value ?? 0) + (this.initialValuesCadastroBoleta?.valor_total ?? 0);
        this.valor_total_boleta.setValue(total);
    }
}